(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hd-checkout-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hd-checkout-comparison')) {
  customElements.define('hd-checkout-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.states = [
        ['AL','Alabama',9.46],['AK','Alaska',1.82],['AZ','Arizona',8.54],['AR','Arkansas',9.48],['CA','California',9.03],['CO','Colorado',7.89],['CT','Connecticut',6.35],['DE','Delaware',0],['DC','District of Columbia',6],['FL','Florida',6.98],['GA','Georgia',7.56],['HI','Hawaii',4.5],['ID','Idaho',6.03],['IL','Illinois',8.98],['IN','Indiana',7],['IA','Iowa',6.94],['KS','Kansas',8.71],['KY','Kentucky',6],['LA','Louisiana',10.13],['ME','Maine',5.5],['MD','Maryland',6],['MA','Massachusetts',6.25],['MI','Michigan',6],['MN','Minnesota',8.14],['MS','Mississippi',7.06],['MO','Missouri',8.44],['MT','Montana',0],['NE','Nebraska',6.98],['NV','Nevada',8.24],['NH','New Hampshire',0],['NJ','New Jersey',6.6],['NM','New Mexico',7.68],['NY','New York',8.54],['NC','North Carolina',7.1],['ND','North Dakota',7.09],['OH','Ohio',7.29],['OK','Oklahoma',9.06],['OR','Oregon',0],['PA','Pennsylvania',6.34],['RI','Rhode Island',7],['SC','South Carolina',7.49],['SD','South Dakota',6.11],['TN','Tennessee',9.61],['TX','Texas',8.2],['UT','Utah',7.42],['VT','Vermont',6.43],['VA','Virginia',5.77],['WA','Washington',9.57],['WV','West Virginia',6.6],['WI','Wisconsin',5.72],['WY','Wyoming',5.39]
      ];
      this.money = new Intl.NumberFormat('en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.price = this.dataset.price === '' ? null : Number(this.dataset.price);
      this.available = this.dataset.available === 'true';
      this.select = this.querySelector('[data-state]');
      this.states.forEach(([code,name]) => this.select.add(new Option(name,code)));
      this.select.addEventListener('change',()=>this.render());
      this.querySelector('[data-controls]').hidden=false;
      const section = this.closest('.shopify-section');
      this.selection = section && section.querySelector('[data-variant-selection]');
      this.onVariant = event => {
        this.revision = (this.revision || 0) + 1;
        this.setVariant(event.detail.variant);
      };
      if (this.selection) {
        this.selection.addEventListener('variant-change',this.onVariant);
        const revision=this.revision || 0;
        if (typeof this.selection.getVariant === 'function') {
          Promise.resolve(this.selection.getVariant()).then(variant=>{
            if (this.isConnected && (this.revision || 0)===revision) this.setVariant(variant);
          }).catch(()=>{});
        }
      }
      this.render();
    }
    disconnectedCallback() {
      if (this.selection) this.selection.removeEventListener('variant-change',this.onVariant);
      this.ready=false;
      this.querySelectorAll('[data-state] option:not(:first-child)').forEach(option=>option.remove());
    }
    setVariant(variant) {
      this.price=variant ? Number(variant.price) : null;
      this.available=Boolean(variant && variant.available);
      this.render();
    }
    render() {
      const valid=Number.isFinite(this.price) && this.price>=0 && this.available;
      const state=this.states.find(item=>item[0]===this.select.value);
      this.querySelector('[data-variant-note]').hidden=valid;
      this.querySelector('[data-result]').hidden=!valid || !state;
      const set=(key,text)=>{this.querySelector('[data-'+key+']').textContent=text;};
      const money=cents=>this.money.format(cents/100);
      if (!valid) return;
      if (!state) return;
      const wyoming=state[0]==='WY';
      const tax=Math.round(this.price*state[2]/100);
      this.querySelector('table').hidden=wyoming;
      set('benefit',wyoming ? this.dataset.wyoming : tax ? this.dataset.difference.replace('{amount}',money(tax)) : this.dataset.zero);
      set('estimate',this.dataset.estimate.replace('{rate}',state[2].toFixed(2)));
      set('price-us',money(this.price));set('price-other',money(this.price));
      set('tax-us',money(0));set('tax-other',money(tax));
      set('total-us',money(this.price));set('total-other',money(this.price+tax));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
